import { AppSession, LoginCredentials } from "@/types/auth";

import { _env } from "@/lib/funifier-env";
import { funifierApi } from "./api";

export async function signIn(credentials: LoginCredentials) {
  try {
    const payload = {
      grant_type: "password",
      apiKey: _env.FUNIFIER_ENV?.apikey,
      ...credentials,
    };
    const { data } = await funifierApi.post("/auth/token", payload);
    return data as AppSession;
  } catch (err) {
    // console.log(err.response.data.message);
  }
}

export async function signUp(credentials: any) {
  try {
    const payload = {
      _id: credentials.username,
      telefone: credentials.telefone,
      ...credentials,
    }

    console.log(_env.FUNIFIER_ENV?.apikey)

    const { data } = await funifierApi.put("/database/registration__c", payload, {
      headers: {
        "Authorization": `Basic ${btoa(_env.FUNIFIER_ENV?.apikey || "")}`,
      }
    });
    return data;
  } catch (err) {
    // console.log(err.response.data.message);
  }
}
